import type { DashboardAlertsTranslations } from "../interfaces/dashboardAlerts";

export const dashboardAlertsTranslations: DashboardAlertsTranslations = {
  alert_payin_title: "Chegou um pagamento de {{amount}}",
  alert_payin_from: "De {{name}}",
  alert_payin_collection_via: "Cobrança via {{rail}}",
  alert_payout_paid_title: "Sua transferência de {{amount}} chegou",
  alert_payout_failed_title: "Sua transferência de {{amount}} não foi concluída",
  alert_payout_failed_body: "Abra o detalhe para ver o que aconteceu.",
  alert_payout_via: "Via {{rail}}",
  alert_batch_completed_title: "Seu lote de pagamentos terminou",
  alert_batch_completed_with_errors_title: "Seu lote de pagamentos terminou com erros",
  alert_batch_failed_title: "Não foi possível concluir seu lote de pagamentos",
  alert_batch_paid: "{{count}} pagos",
  alert_batch_failed_rows: "{{count}} com erro",
  alert_batch_paid_one: "1 pago",
  alert_batch_failed_rows_one: "1 com erro",
  alert_card_approved_title: "Compra de {{amount}} aprovada",
  alert_card_declined_title: "Compra de {{amount}} recusada",
  alert_card_refund_title: "Reembolso de {{amount}} no seu cartão",
  alert_card_reversal_title: "Uma compra de {{amount}} foi estornada",
  alert_card_detail: "Cartão •••• {{last4}}",
  alert_card_approved_no_amount: "Compra aprovada no seu cartão",
  alert_card_declined_no_amount: "Compra recusada no seu cartão",
  alert_card_refund_no_amount: "Reembolso no seu cartão",
  alert_card_reversal_no_amount: "Uma compra foi estornada",
  alert_view_transaction: "Ver transação",
  alert_view_batch: "Ver lote",
  summary_payins_breb_key: "Chegaram {{count}} pagamentos nas suas chaves",
  summary_payins_collections: "{{count}} cobranças foram pagas",
  summary_payouts_paid: "Chegaram {{count}} das suas transferências",
  summary_payouts_failed: "{{count}} transferências não foram concluídas",
  summary_payout_batches_done: "{{count}} lotes de pagamentos terminaram",
  summary_cards_purchase_approved: "{{count}} compras aprovadas nos seus cartões",
  summary_cards_purchase_declined: "{{count}} compras recusadas nos seus cartões",
  summary_cards_refund: "{{count}} reembolsos nos seus cartões",
  summary_total: "{{amount}} no total",
  summary_view: "Ver todos",
  section_eyebrow: "Notificações",
  section_title: "Avisos no dashboard",
  section_sub:
    "Uma mensagem no canto da tela quando algo acontece, enquanto o dashboard está aberto. Se chegarem vários seguidos, eles se juntam em um.",
  section_count: "{{on}} de {{total}} ativos",
  group_payins: "Pagamentos recebidos",
  group_payouts: "Transferências",
  group_payout_batches: "Pagamentos em lote",
  group_cards: "Cartões",
  type_payins_breb_key: "Pagamentos nas suas chaves Bre-B",
  type_payins_breb_key_hint:
    "Quando alguém paga com seu QR de qualquer valor ou digitando sua chave. Com o QR aberto, o aviso aparece dentro do QR.",
  type_payins_collections: "Cobranças pagas",
  type_payins_collections_hint:
    "Quando pagam uma cobrança que você criou: QR com valor, PSE, Nequi, Botón Bancolombia, PIX ou SPEI, ou uma transferência para sua conta.",
  type_payouts_paid: "Transferências que chegaram",
  type_payouts_paid_hint: "Quando o destino confirma uma transferência que você fez.",
  type_payouts_failed: "Transferências não concluídas",
  type_payouts_failed_hint: "Quando uma transferência é recusada ou estornada.",
  type_payout_batches_done: "Lotes concluídos",
  type_payout_batches_done_hint: "Quando um lote de pagamentos termina de ser executado, com ou sem erros.",
  type_cards_purchase_approved: "Compras aprovadas",
  type_cards_purchase_approved_hint: "Cada compra aprovada com os cartões da sua organização.",
  type_cards_purchase_declined: "Compras recusadas",
  type_cards_purchase_declined_hint: "Quando o estabelecimento ou o emissor recusa uma compra.",
  type_cards_refund: "Reembolsos e estornos",
  type_cards_refund_hint: "Quando um estabelecimento devolve dinheiro a um cartão ou uma compra é estornada.",
  browser_note: "Salvos neste navegador: em outro computador ou celular você pode escolher diferente.",
  whatsapp_note: "Também pelo WhatsApp, mesmo com o dashboard fechado?",
  whatsapp_payments_link: "Avisos de pagamentos",
  whatsapp_cards_link: "Avisos de cartões",
  sound_label: "Som dos avisos",
  sound_hint: "Desligue para silenciar todos sem mudar o que você escolheu em cada um.",
  mode_sound: "Com som",
  mode_silent: "Sem som",
  mode_off: "Desligado",
  mode_group_aria: "Como avisamos sobre {{label}}",
  sound_listen: "Ouvir",
  sound_listen_problem: "Se falhar",
  sound_desc_payins: "Um sininho que sobe.",
  sound_desc_payouts: "Duas notas de madeira: sobem se chegou, descem se não.",
  sound_desc_payout_batches: "Tique, tique, tique e um sino; desce se algo falhou.",
  sound_desc_cards: "O bipe-bipe da maquininha; um bipe que desce se for recusada.",
  intro_title: "É assim que avisamos",
  intro_body:
    "Quando algo acontece com seu dinheiro, uma mensagem aparece no topo da tela enquanto o dashboard está aberto. Cada seção soa diferente, para você saber o que é sem olhar.",
  intro_footer: "Escolha quais tocam, quais só aparecem e quais desligar.",
  intro_settings: "Configurar avisos",
  intro_dismiss: "Entendi",
  intro_close: "Fechar",
};
